import React from 'react';

import styled from '@emotion/styled';

import PostJobModal from '../../../components/Modal/ModalActions/PostJobModal';
import ShowModalButton from '../../../components/Modal/ShowModalButton';
import { ModalProvider } from '../../../context/ModalContext';
import { Modal } from '../../../components/Modal/Modal';

interface HeaderModalButtonProps {
  children: string;
  text?: string;
  className?: string;
}

const HeaderModalButton: React.FC<HeaderModalButtonProps> = ({
  children,
  text,
  className
}) => {
  return (
    <ModalProvider>
      <Container>
        <Box text={text}>
          {text && <TextDescription>{text}</TextDescription>}
          <ShowModalButton className={`${className} post-job`}>{children}</ShowModalButton>
        </Box>
      </Container>
      <Modal>
        <PostJobModal />
      </Modal>
    </ModalProvider>
  );
};

export default HeaderModalButton;

const Container = styled.div`
  display: flex;
  width: fit-content;
  position: relative;

  .mobileonly {
    display: none;

    @media (max-width: 884px) {
      display: flex;
    }
  }
`;

interface IBox {
  text?: string;
}

const Box = styled.div<IBox>`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  justify-content: ${({ text }) => (text ? 'space-between' : 'center')};
`;

const TextDescription = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.mainBlue};
  font-weight: 500;
  font-size: 18px;
`;
